import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 4V20M4 12H20",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
